"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

var _segmentBar = _interopRequireDefault(require("./segment-bar"));

var _segmentDetails = _interopRequireDefault(require("./segment-details"));

var _segmentTitle = _interopRequireDefault(require("./segment-title"));

var _segmentStepModule = _interopRequireDefault(require("./segment-step.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// calculate new intermediate indices after segment range has changed
var getNewIntermediateIndices = function getNewIntermediateIndices(startIndex, endIndex, oldStartIndex, oldEndIndex, oldIntermediateIndices) {
  var allIntermediateIndices = _toConsumableArray(Array(endIndex - startIndex - 1).keys()).map(function (index) {
    return index + startIndex + 1;
  });

  return allIntermediateIndices.filter(function (index) {
    var wasInPreviousSegmentRange = index > oldStartIndex && index < oldEndIndex; // keep using value of old indices if the index was in the previous segment range

    if (wasInPreviousSegmentRange) {
      return oldIntermediateIndices.includes(index);
    } // index was not in the previous segment range, include it in the segment as default


    return true;
  });
};

var Segments = function Segments(_ref) {
  var projects = _ref.projects,
      alarms = _ref.alarms,
      tour = _ref.tour,
      onUpdate = _ref.onUpdate,
      selectedSegment = _ref.selectedSegment,
      onSelectedSegment = _ref.onSelectedSegment;
  var intl = (0, _nicbaseTranslation.useIntl)();
  var containerRef = (0, _react.useRef)();
  var _tour$segments = tour.segments,
      tourSegments = _tour$segments === void 0 ? [] : _tour$segments;

  var _useState = (0, _react.useState)(function () {
    if (tourSegments.length > 0) {
      return tourSegments.map(function (segment) {
        var startIndex = segment.validityWayPointIndexRange[0];
        var endIndex = segment.validityWayPointIndexRange[segment.validityWayPointIndexRange.length - 1];
        return {
          startIndex: startIndex,
          endIndex: endIndex,
          intermediateIndices: segment.validityWayPointIndexRange.filter(function (index) {
            return index !== startIndex && index !== endIndex;
          })
        };
      });
    }

    return [{
      startIndex: null,
      endIndex: null
    }];
  }),
      _useState2 = _slicedToArray(_useState, 2),
      segments = _useState2[0],
      setSegments = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      resizingStartSegment = _useState4[0],
      setResizingStartSegment = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      resizingEndSegment = _useState6[0],
      setResizingEndSegment = _useState6[1];

  var dispatch = (0, _react.useCallback)(function (newSegments) {
    onUpdate({
      segments: newSegments.map(function (segment, index) {
        var startIndex = segment.startIndex,
            endIndex = segment.endIndex,
            _segment$intermediate = segment.intermediateIndices,
            intermediateIndices = _segment$intermediate === void 0 ? [] : _segment$intermediate;
        return _objectSpread(_objectSpread({}, tourSegments[index]), {}, {
          validityWayPointIndexRange: [startIndex].concat(_toConsumableArray(intermediateIndices), [endIndex])
        });
      })
    });
  }, [onUpdate, tourSegments]);
  var firstUpdate = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    if (tourSegments.length > 0 && document.getElementById("anchor-0-".concat(tourSegments.length))) {
      if (firstUpdate.current) {
        firstUpdate.current = false;
        setSegments(tourSegments.map(function (segment, segmentIndex) {
          var startIndex = segment.validityWayPointIndexRange[0];
          var endIndex = segment.validityWayPointIndexRange[segment.validityWayPointIndexRange.length - 1];
          var startAnchor = document.getElementById("anchor-".concat(startIndex, "-").concat(segmentIndex + 1));
          var endAnchor = document.getElementById("anchor-".concat(endIndex, "-").concat(segmentIndex + 1));

          if (containerRef.current) {
            containerRef.current.scrollTop = (startAnchor === null || startAnchor === void 0 ? void 0 : startAnchor.offsetTop) + (startAnchor === null || startAnchor === void 0 ? void 0 : startAnchor.offsetHeight) / 2;
          }

          return {
            startIndex: startIndex,
            endIndex: endIndex,
            intermediateIndices: segment.validityWayPointIndexRange.filter(function (index) {
              return index !== startIndex && index !== endIndex;
            }),
            x: (startAnchor === null || startAnchor === void 0 ? void 0 : startAnchor.offsetWidth) / 2 - 16,
            y: (startAnchor === null || startAnchor === void 0 ? void 0 : startAnchor.offsetTop) + (startAnchor === null || startAnchor === void 0 ? void 0 : startAnchor.offsetHeight) / 2,
            height: (endAnchor === null || endAnchor === void 0 ? void 0 : endAnchor.offsetTop) - (startAnchor === null || startAnchor === void 0 ? void 0 : startAnchor.offsetTop)
          };
        }));
      }
    }
  }, [tourSegments]); // reset resizing segment on mouseup and set segment pois

  (0, _react.useEffect)(function () {
    var onMouseUp = function onMouseUp() {
      if (resizingStartSegment !== null || resizingEndSegment !== null) {
        var segmentIndex = resizingStartSegment !== null && resizingStartSegment !== void 0 ? resizingStartSegment : resizingEndSegment;
        var resizingSegment = segments[segmentIndex];
        var segmentStart = resizingSegment.y,
            height = resizingSegment.height,
            oldStartIndex = resizingSegment.startIndex,
            oldEndIndex = resizingSegment.endIndex,
            oldIntermediateIndices = resizingSegment.intermediateIndices;
        var segmentEnd = segmentStart + height; // get nearest anchors to segment borders

        var regex = new RegExp("anchor-\\d+-".concat(segmentIndex + 1));
        var anchors = Array.from(document.querySelectorAll('[id^=anchor]')).filter(function (anchor) {
          return regex.test(anchor.id);
        });
        var nearestAnchorToStart = anchors.reduce(function (result, nextAnchor) {
          if (!result) {
            return nextAnchor;
          }

          var nextPos = nextAnchor.offsetTop + nextAnchor.offsetHeight / 2;
          var resultPos = result.offsetTop + result.offsetHeight / 2;

          if (Math.abs(segmentStart - nextPos) < Math.abs(segmentStart - resultPos)) {
            return nextAnchor;
          }

          return result;
        }, null);
        var nearestAnchorToEnd = anchors.reduce(function (result, nextAnchor) {
          if (!result) {
            return nextAnchor;
          }

          var nextPos = nextAnchor.offsetTop + nextAnchor.offsetHeight / 2;
          var resultPos = result.offsetTop + result.offsetHeight / 2;

          if (Math.abs(segmentEnd - nextPos) < Math.abs(segmentEnd - resultPos)) {
            return nextAnchor;
          }

          return result;
        }, null); // recalculate segment position

        var newY = nearestAnchorToStart.offsetTop + nearestAnchorToStart.offsetHeight / 2;
        var newHeight = nearestAnchorToEnd.offsetTop - nearestAnchorToStart.offsetTop; // get new pois

        var startIndex = Number(nearestAnchorToStart.id.match(/\d+/g)[0]);
        var endIndex = Number(nearestAnchorToEnd.id.match(/\d+/g)[0]); // reset resizing segment and update segment

        setResizingStartSegment(null);
        setResizingEndSegment(null);
        var newSegments = [].concat(_toConsumableArray(segments.slice(0, segmentIndex)), [_objectSpread(_objectSpread({}, resizingSegment), {}, {
          startIndex: startIndex,
          endIndex: endIndex,
          intermediateIndices: getNewIntermediateIndices(startIndex, endIndex, oldStartIndex, oldEndIndex, oldIntermediateIndices),
          y: newY,
          height: newHeight
        })], _toConsumableArray(segments.slice(segmentIndex + 1)));
        setSegments(newSegments);
        dispatch(newSegments);
      }
    };

    window.addEventListener('mouseup', onMouseUp);
    return function () {
      return window.removeEventListener('mouseup', onMouseUp);
    };
  }, [resizingStartSegment, resizingEndSegment, segments, dispatch]);

  var onMouseMoveInSegmentRow = function onMouseMoveInSegmentRow(event, rowId) {
    // change segment dimensions if a segment is currently being resized
    if (resizingStartSegment !== null || resizingEndSegment !== null) {
      var firstAnchor = document.getElementById("anchor-0-1");
      var minY = firstAnchor.offsetTop + firstAnchor.offsetHeight / 2;
      var segmentRow = document.getElementById(rowId);
      var rowRect = segmentRow.getBoundingClientRect();
      var relativeMouseY = event.clientY - rowRect.top;
      var segmentIndex = resizingStartSegment !== null && resizingStartSegment !== void 0 ? resizingStartSegment : resizingEndSegment;
      var resizingSegment = segments[segmentIndex];
      var endIndex = resizingSegment.endIndex,
          y = resizingSegment.y,
          height = resizingSegment.height;
      var endAnchor = document.getElementById("anchor-".concat(endIndex, "-").concat(segmentIndex + 1));
      var newY = y;
      var newHeight = height; // is resizing start of segment

      if (resizingStartSegment !== null) {
        var newHeightByMousePosition = endAnchor.offsetTop + endAnchor.offsetHeight / 2 - relativeMouseY; // check for min height to prevent segment to become to small

        if (newHeightByMousePosition > 80) {
          newY = relativeMouseY;
          newHeight = newHeightByMousePosition;
        }
      } // is resizing end of segment


      if (resizingEndSegment !== null) {
        newHeight = Math.max(80, relativeMouseY - y);
      } // do not update if new dimensions are invalid


      if (newY < minY) {
        return;
      }

      var newSegments = [].concat(_toConsumableArray(segments.slice(0, segmentIndex)), [_objectSpread(_objectSpread({}, resizingSegment), {}, {
        y: newY,
        height: newHeight
      })], _toConsumableArray(segments.slice(segmentIndex + 1)));
      setSegments(newSegments);
      dispatch(newSegments);
    }
  };

  var addSegment = function addSegment() {
    setSegments(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        startIndex: null,
        endIndex: null,
        intermediateIndices: []
      }]);
    });
    dispatch([].concat(_toConsumableArray(segments), [{
      startIndex: null,
      endIndex: null
    }]));
  };

  var addSegmentStart = function addSegmentStart(_ref2) {
    var segmentIndex = _ref2.segmentIndex,
        poiIndex = _ref2.poiIndex;
    var isLastIndex = poiIndex === tour.wayPoints.length - 1;
    var startIndex = isLastIndex ? poiIndex - 1 : poiIndex;
    var endIndex = isLastIndex ? poiIndex : poiIndex + 1;
    var startAnchor = document.getElementById("anchor-".concat(startIndex, "-").concat(segmentIndex + 1));
    var endAnchor = document.getElementById("anchor-".concat(endIndex, "-").concat(segmentIndex + 1));
    var newSegments = [].concat(_toConsumableArray(segments.slice(0, segmentIndex)), [{
      startIndex: startIndex,
      endIndex: endIndex,
      intermediateIndices: _toConsumableArray(Array(endIndex - startIndex - 1).keys()).map(function (index) {
        return index + startIndex;
      }),
      x: startAnchor.offsetWidth / 2 - 16,
      y: startAnchor.offsetTop + startAnchor.offsetHeight / 2,
      height: endAnchor.offsetTop - startAnchor.offsetTop
    }], _toConsumableArray(segments.slice(segmentIndex + 1)));
    setSegments(newSegments);
    dispatch(newSegments);
  };

  var onDeleteSegment = function onDeleteSegment(segmentIndex) {
    var newSegments = segments.slice(0);
    newSegments.splice(segmentIndex, 1);
    setSegments(newSegments);
    dispatch(newSegments);
    onSelectedSegment(null);
  };

  var onIncludeIntermediateWaypointChange = function onIncludeIntermediateWaypointChange(isIncluded, segmentIndex, waypointIndex) {
    var segment = segments[segmentIndex];
    var intermediateIndices = segment.intermediateIndices;

    if (isIncluded) {
      intermediateIndices = [].concat(_toConsumableArray(intermediateIndices), [waypointIndex]);
    } else {
      intermediateIndices = intermediateIndices.filter(function (index) {
        return index !== waypointIndex;
      });
    }

    var newSegments = [].concat(_toConsumableArray(segments.slice(0, segmentIndex)), [_objectSpread(_objectSpread({}, segment), {}, {
      intermediateIndices: intermediateIndices
    })], _toConsumableArray(segments.slice(segmentIndex + 1)));
    setSegments(newSegments);
    dispatch(newSegments);
  };

  if (!tour.wayPoints.some(function (waypoint) {
    return waypoint.poiId;
  }) || tour.scheduledStartTime || tour.scheduledEndTime) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex flex-1 items-center justify-center"
    }, /*#__PURE__*/_react["default"].createElement("span", null, intl.formatMessage({
      id: 'widgets.tourBoard.road.createTour.noWaypoints'
    })));
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: containerRef,
    className: "items-center flex flex-row flex-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-1/5 pt-8 text-base"
  }, tour.wayPoints.map(function (poi, index) {
    var _tourSegments$selecte, _tourSegments$selecte2, _tourSegments$selecte3, _tourSegments$selecte4;

    return /*#__PURE__*/_react["default"].createElement("div", {
      key: poi.poiId,
      className: _segmentStepModule["default"].circleContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-center"
    }, index === 0 || index === tour.wayPoints.length - 1 ? /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Location, {
      className: (0, _classnames["default"])(_segmentStepModule["default"].icon, _defineProperty({}, _segmentStepModule["default"].selectedIcon, selectedSegment !== null && !((_tourSegments$selecte = tourSegments[selectedSegment]) !== null && _tourSegments$selecte !== void 0 && (_tourSegments$selecte2 = _tourSegments$selecte.validityWayPointIndexRange) !== null && _tourSegments$selecte2 !== void 0 && _tourSegments$selecte2.some(function (waypoint) {
        return waypoint === index;
      }))))
    }) : /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_segmentStepModule["default"].circle, _defineProperty({}, _segmentStepModule["default"].selectedCircle, selectedSegment !== null && !((_tourSegments$selecte3 = tourSegments[selectedSegment]) !== null && _tourSegments$selecte3 !== void 0 && (_tourSegments$selecte4 = _tourSegments$selecte3.validityWayPointIndexRange) !== null && _tourSegments$selecte4 !== void 0 && _tourSegments$selecte4.some(function (waypoint) {
        return waypoint === index;
      }))))
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "select-none truncate",
      title: poi.poiName
    }, poi.poiName)));
  })), selectedSegment === null ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex w-3/5"
  }, segments.map(function (segment, segmentIndex) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      id: "segment-row-".concat(segmentIndex + 1),
      key: "segment-row-".concat(segmentIndex + 1),
      className: "w-32 relative flex-shrink-0",
      onMouseMove: function onMouseMove(event) {
        return onMouseMoveInSegmentRow(event, "segment-row-".concat(segmentIndex + 1));
      }
    }, /*#__PURE__*/_react["default"].createElement(_segmentTitle["default"], {
      onDelete: onDeleteSegment,
      segmentIndex: segmentIndex
    }, "Segment ", segmentIndex + 1), tour.wayPoints.map(function (poi, index) {
      var _segment$intermediate2;

      var isPartOfSegment = (_segment$intermediate2 = segment.intermediateIndices) === null || _segment$intermediate2 === void 0 ? void 0 : _segment$intermediate2.includes(index);
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "anchor-".concat(index, "-").concat(segmentIndex + 1),
        key: "anchor-".concat(poi.poiId, "-").concat(segmentIndex + 1),
        className: "flex items-center justify-center h-32 border-r border-gray-400"
      }, !segment.startIndex && !segment.endIndex && /*#__PURE__*/_react["default"].createElement("button", {
        title: intl.formatMessage({
          id: 'widgets.tourBoard.road.createTour.addSegment'
        }),
        onClick: function onClick() {
          return addSegmentStart({
            segmentIndex: segmentIndex,
            poiIndex: index
          });
        },
        className: "opacity-30 hover:opacity-100"
      }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Plus, {
        className: "fill-primary rounded w-5 h-5"
      })), Number.isInteger(segment.startIndex) && Number.isInteger(segment.endIndex) && index > segment.startIndex && index < segment.endIndex && resizingStartSegment !== segmentIndex && resizingEndSegment !== segmentIndex && /*#__PURE__*/_react["default"].createElement("label", {
        className: (0, _classnames["default"])('relative cursor-pointer flex z-1 p-4 transition-colors duration-400 ease-in-out', {
          'bg-white': !isPartOfSegment,
          'bg-transparent': isPartOfSegment
        })
      }, /*#__PURE__*/_react["default"].createElement("input", {
        className: "appearance-none cursor-pointer h-4 w-4 rounded-sm bg-gray-300 transform transition-all duration-400 ease-in-out hover:scale-110 checked:bg-transparent",
        type: "checkbox",
        checked: isPartOfSegment,
        onChange: function onChange() {
          return onIncludeIntermediateWaypointChange(!isPartOfSegment, segmentIndex, index);
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 rotate-45 border-white w-1 h-2 pointer-events-none', {
          hidden: !isPartOfSegment
        }),
        style: {
          borderRightWidth: '2px',
          borderBottomWidth: '2px'
        }
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "sr-only"
      }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "widgets.tourBoard.road.createTour.includeWaypoint"
      }))));
    }), (segment.startIndex !== null || segment.startIndex !== undefined) && (segment.endIndex !== null || segment.endIndex !== undefined) ? /*#__PURE__*/_react["default"].createElement(_segmentBar["default"], {
      startPoi: tour.wayPoints[segment.startIndex],
      endPoi: tour.wayPoints[segment.endIndex],
      intermediatePois: tour.wayPoints.filter(function (_, index) {
        var _segment$intermediate3;

        return (_segment$intermediate3 = segment.intermediateIndices) === null || _segment$intermediate3 === void 0 ? void 0 : _segment$intermediate3.includes(index);
      }),
      segment: segment,
      segmentIndex: segmentIndex,
      onSelectedSegment: onSelectedSegment,
      isResizingSegment: resizingStartSegment === segmentIndex || resizingEndSegment === segmentIndex,
      onResizingStartSegment: setResizingStartSegment,
      onResizingEndSegment: setResizingEndSegment
    }) : null);
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-32 flex justify-center flex-shrink-0"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    title: intl.formatMessage({
      id: 'widgets.tourBoard.road.createTour.addSection'
    }),
    onClick: addSegment,
    className: "align-center h-6 w-6"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Plus, {
    className: "fill-primary rounded h-5 w-5"
  })))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex w-3/5"
  }, /*#__PURE__*/_react["default"].createElement(_segmentDetails["default"], {
    key: "selected-segment-".concat(selectedSegment),
    projects: projects,
    alarms: alarms,
    segments: tourSegments,
    selectedSegment: selectedSegment,
    onUpdate: onUpdate,
    onDelete: onDeleteSegment
  })));
};

Segments.propTypes = {
  projects: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].number,
    projectName: _propTypes["default"].string,
    endpointId: _propTypes["default"].number,
    sharedData: _propTypes["default"].arrayOf(_propTypes["default"].string)
  })),
  alarms: _propTypes["default"].arrayOf(_propTypes["default"].shape()).isRequired,
  tour: _propTypes["default"].shape({
    scheduledStartTime: _propTypes["default"].string,
    scheduledEndTime: _propTypes["default"].string,
    segments: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      validityWayPointIndexRange: _propTypes["default"].arrayOf(_propTypes["default"].number),
      projects: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
      alarms: _propTypes["default"].arrayOf(_propTypes["default"].number)
    })),
    wayPoints: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      poiId: _propTypes["default"].string,
      frontendId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
    }))
  }),
  onUpdate: _propTypes["default"].func,
  onSelectedSegment: _propTypes["default"].func,
  selectedSegment: _propTypes["default"].number
};

var noop = function noop() {};

Segments.defaultProps = {
  projects: [],
  tour: {},
  onUpdate: noop,
  onSelectedSegment: noop,
  selectedSegment: null
};

var _default = (0, _nicbaseSecurity.authorize)('PORTAL')(['module.tour.road'])(Segments);

exports["default"] = _default;